<template>
 <main class="main">
    <div class="inicio" id="home">
        <div class="content  ">
          <div class="text mb-5 " > 
              <h3>Olá, eu sou  </h3>
              <h1>Josemar Cafumana</h1>
              <h3>Desenvolvedor Full-stack</h3>
          </div>
        <div class="botoes my-4">
              <a href="https://www.linkedin.com/in/josemar-cafumana-web-developer/" target="_blank" class="btn-gradient-purple me-4"><img alt="logo do linkedin" src="../assets/linkedin.svg"> Linkedin</a>
              <a href="https://github.com/Josemar-cafumana" target="_blank" class="btn-gradient-pink"> <img  alt="logo do github" src="../assets/github.svg"> Github</a>
          </div>
        </div>
    </div>
    <!-- Seção sobre mim -->
    <section class="sobre-mim" id="about">
        <div class="dados-pessoais">
          <div class="row">
            <div class="image col-md-6 d-flex justify-content-center align-items-center mb-4">
              <div class="image-wrapper" data-aos="fade-right" >
                 <img src="../assets/josemar.jpg" alt="foto pessoal">
              </div>
            </div>
            <div class=" sobre col-md-6 d-flex justify-content-start align-items-center ">
            
            <div class="sobre-wrapper">
            <h3>Sobre mim</h3>
            <div class="descricao mt-5">
              <h4 class="my-3">Luanda, Angola</h4>
              <p class="mb-3">Sou um desenvolvedor Full-stack focado em desenvolver solucões Web. Atualmente trabalho como freelancer com projetos de tamanho pequeno, médio e grande porte. Aprendendo coisas novas todos os dias rumo ao espaço.</p>
            </div>
            <div class="redes-sociais ">
                <a href="#"><img alt="logo do twitter" src="../assets/twitter.svg"></a>
                <a href="#"><img  alt="logo do twitch" src="../assets/twitch.svg"></a>
                <a href="#"><img  alt="logo do youtube" src="../assets/youtube.svg"></a>
                <a href="#"><img  alt="logo do codepen" src="../assets/codepen.svg"></a>
                <a href="#"><img  alt="logo do facebook" src="../assets/facebook.svg"></a>
            </div>
            <div class="botoes my-3">
                <a href="https://drive.google.com/file/d/1BXGdPeJBcbDpZiq2ps1O01o9ns0d91l7/view?usp=sharing" target="_blank" class="btn-gradient-purple me-4"><img alt="icone download" src="../assets/download-cloud.svg"> Currículo</a>
              <a href="mailto:josemarcafumana890@gmail.com"  class="btn-gradient-pink"> <img  alt="icone email" src="../assets/mail.svg"> E-mail</a>
            </div>

            </div>
        
         
            </div>
          </div>
          
         
        </div>
    </section>

    <section class="experiencia px-5 tex-center" id="skills">
      <h3 class="text-center">Habilidades</h3>
        <div class="row d-flex justify-content-center">
      
        <div class="col-md-6 skills">
            <div class="skill-container">
              <div class="box"  data-aos="fade-up">
                <img  alt="icone html" src="../assets/skill-1.svg" class="ms-2">
                <p>HTML</p>
              </div>
              <div class="box"  data-aos="fade-up" >
                <img  alt="icone html" src="../assets/skill-2.svg" class="ms-2">
                <p>CSS</p>
              </div>
              <div class="box"  data-aos="fade-up">
                <img  alt="icone html" src="../assets/skill-3.svg" class="ms-2">
                <p>JS</p>
              </div>
              <div class="box"  data-aos="fade-up">
                <img  alt="icone html" src="../assets/skill-4.svg" class="ms-2">
                <p>PHP</p>
              </div>
              <div class="box"  data-aos="fade-up">
                <img  alt="icone html" src="../assets/skill-5.svg" class="ms-2">
                <p>MYSQL</p>
              </div>
              <div class="box"  data-aos="fade-up">
                <img  alt="icone html" src="../assets/skill-6.svg" class="ms-2">
                <p>LARAVEL</p>
              </div>
              <div class="box"  data-aos="fade-up">
                <img  alt="icone html" src="../assets/skill-7.svg" class="ms-2">
                <p>VUEJS</p>
              </div>
              <div class="box"  data-aos="fade-up">
                <img  alt="icone html" src="../assets/skill-8.svg" class="ms-2">
                <p>NUXTJS</p>
              </div>
            </div>
        </div>
      
        </div>
    </section>

    <section class="projectos" id="projects"> 
      <h3>Projectos</h3>
      
      <div class="row ">

        <div  class=" box-image col-md-6  d-flex justify-content-center align-items-center my-5"  data-aos="fade-right" >
           
              <div class="box">
              <div class="image projecto1">
                <img  src="../assets/projecto-1.png" alt="">
              </div>
              <div class="descricao">
                  <h3>projecto Anova</h3>
                
              </div>
              <div class="tecnologias">
                   <img src="../assets/html.svg" alt="html">
                  <img src="../assets/css.svg" alt="css">
                  <img src="../assets/javascript.svg" alt="javascript">
                  <img src="../assets/laravel-icon.svg" alt="laravel">
              </div>
              <a href="#" class="btn-gradient-purple mt-5"> <img src="../assets/link.svg">Visualizar</a>
            </div>
        </div>
        <div  class=" box-image col-md-6  d-flex justify-content-center align-items-center my-5"  data-aos="fade-right">
           
              <div class="box">
              <div class="image projecto1">
                <img  src="../assets/projecto-2.png" alt="">
              </div>
              <div class="descricao">
                  <h3>Website de Construção</h3>
                
              </div>
              <div class="tecnologias">
                   <img src="../assets/html.svg" alt="html">
                  <img src="../assets/css.svg" alt="css">
                  <img src="../assets/javascript.svg" alt="javascript">
              </div>
              <a href="https://construcaowebsite.netlify.app/" class="btn-gradient-purple mt-5"> <img src="../assets/link.svg">Visualizar</a>
            </div>
        </div>
        <div  class=" box-image col-md-6  d-flex justify-content-center align-items-center my-5 "  data-aos="fade-right">
           
              <div class="box">
              <div class="image projecto1">
                <img  src="../assets/projecto-3.png" class="img-fluid" alt="">
              </div>
              <div class="descricao">
                  <h3>Projecto IFOOD</h3>
                
              </div>
              <div class="tecnologias">
                   <img src="../assets/html.svg" alt="html">
                  <img src="../assets/css.svg" alt="css">
                  <img src="../assets/javascript.svg" alt="javascript">
              </div>
              <a href="https://restaurantesite.netlify.app/" class="btn-gradient-purple mt-5"> <img src="../assets/link.svg">Visualizar</a>
            </div>
        </div>
        <div  class=" box-image col-md-6  d-flex justify-content-center align-items-center my-5"  data-aos="fade-right">
           
              <div class="box">
              <div class="image projecto1">
                <img  src="../assets/projecto-4.png" alt="">
              </div>
              <div class="descricao">
                  <h3>Portal edificio</h3>
                
              </div>
              <div class="tecnologias">
                   <img src="../assets/html.svg" alt="html">
                  <img src="../assets/css.svg" alt="css">
                  <img src="../assets/javascript.svg" alt="javascript">
              </div>
              <a href="#" class="btn-gradient-purple mt-5"> <img src="../assets/link.svg">Visualizar</a>
            </div>
        </div>
      
      </div>
    </section>

    <section class="contacto" id="contact">
            <h3>Entrar em contacto</h3>
            <div class="row">
              <div class="col-md-6 d-flex align-items-center justify-content-center justify-content-md-start">
                <div class="info my-3 ps-md-5">
                  <a href=""  data-aos="fade-down"><img  alt="icone email" src="../assets/phone.svg" class="ms-2"> +244 947754715</a>
                  <a href=""  data-aos="fade-down"><img  alt="icone email" src="../assets/mail.svg" class="ms-2"> josemarcafumana890@gmail.com</a>
                </div>
              </div>
              <div class="col-md-6">
                <form>

                    <div class="mb-5">
                      <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Nome">
                    </div>
                    <div class="mb-5">
                      <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="Email">
                    </div>
                    <div class="mb-5">
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3">Mensagem</textarea>
                  </div>

                  <div class="mb-4 mt-5 d-flex justify-content-center ">
                       <a href="#"  class="btn-gradient-purple d-flex justify-content-center mt-4"> <span>Enviar <img  alt="icone email" src="../assets/send.svg" class="ms-2"></span>  </a>
                  </div>

                </form>
              </div>
            </div>
    </section>

 </main>
</template>

<script>
import  Aos from 'aos'

export default {
  name: "Home",
  mounted() {
        Aos.init();
 
   
  },
  data(){
    return {
          projectos: [
            {id:1, titulo: "Website de Construção"},
            {id:2, titulo: 'Restaurante Website'},
            {id:3, titulo: "Website de Construção"},
            {id:4, titulo: 'Restaurante Website'},
          ]
    }
  },
  components: {

  },
};
</script>
<style src="./Home.scss" lang="scss"></style>